const calendarEvents: StandardObjectInterface = {
    initializeDatePicker: 'intialize-date-picker',
    datePickerInitialised: 'date-picker-initialised',
    addRow: 'add-row',
    removeRow: 'remove-row',
    editState: 'edit-state',
    editPeriod: 'edit-period',
    startDateChanged: 'start-date-changed',
    endDateChanged: 'end-date-changed',
    activePeriod: 'active-period',
    clearSelection: 'clear-selection',
    setArrivalDate: 'set-arrival-date',
    setDepartureDate: 'set-departure-date',
    updateRange: 'update-range',
    saveCalendar: 'save-calendar',
    deleteCalendar: 'delete-calendar',
    openDatepicker: 'open-datepicker',
    calendarUpdated: 'calendar-updated',
    blockAdded: 'block-added',
    blockAddFailed: 'block-add-failed',
    blockDeleted: 'block-deleted',
    blockDeleteFailed: 'block-delete-failed',
    blockUpdated: 'block-updated',
    blockUpdateFailed: 'block-update-failed',
    periodAdded: 'period-added',
    periodAddFailed: 'period-add-failed',
    periodDeleted: 'period-deleted',
    periodDeleteFailed: 'period-delete-failed',
    periodUpdated: 'period-updated',
    periodUpdateFailed: 'period-update-failed',
    periodModalClosed: 'period-modal-closes',
    periodModalClose: 'period-modal-close'
};

export default calendarEvents;

export enum PeriodType {
    Period = 'period',
    Block = 'block',
    DateRange = 'dateRange'
}
